<template>
  <div class="message-counter">
    <div class="w-1200 content">
      <div class="card">
        <div class="title">
          <span class="shop">我是采购商</span>
          <el-tag type="danger" size="mini">new</el-tag>
        </div>
        <div class="message-item" v-for="item in frist" :key="item.id">
          <span class="desc-title">{{ item.remarks }}</span>
          <el-switch
            @change="handleChange(item.key, item.value)"
            v-model="item.value"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
          <span class="desc-from">
            {{ item.desc }}
          </span>
        </div>
      </div>
      <div class="card">
        <div class="title">
          <span class="shop">我是供货商</span>
          <el-tag type="danger" size="mini">new</el-tag>
        </div>
        <div class="message-item" v-for="item in second" :key="item.id">
          <span class="desc-title">{{ item.remarks }}</span>
          <el-switch
            @change="handleChange(item.key, item.value)"
            v-model="item.value"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
          <span class="desc-from">
            {{ item.desc }}
          </span>
        </div>
      </div>
      <div class="card">
        <div class="title">
          <span class="shop">系统提醒</span>
          <el-tag type="danger" size="mini">new</el-tag>
        </div>
        <div class="message-item" v-for="item in third" :key="item.id">
          <span class="desc-title">{{ item.remarks }}</span>
          <el-switch
            @change="handleChange(item.key, item.value)"
            v-model="item.value"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
          <span class="desc-from">
            {{ item.desc }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { get_config, setSetting } from "@/api/modules/user.js";
export default {
  name: "message-counter",
  data() {
    return {
      from: {
        new: true,
      },
      detail: {},
      keyOne: ["notice_new_baojia", "notice_payment", "notice_receive"],
      keyTwo: ["notice_new_xundan", "notice_fahuo"],
      keyThree: ["notice_feedback"],
      frist: [],
      second: [],
      third: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleChange(key, value) {
      setSetting({ key: key }).then((res) => {
        if (res.data.code == 10000) {
          this.$message.success({
            message: res.data.message,
            type: "success",
            duration: 1000,
            offset: 100,
          });
        } else {
          this.$message.error({
            message: res.data.message,
            type: "error",
            duration: 1000,
            offset: 100,
          });
        }
      });
    },
    getList() {
      get_config().then((res) => {
        this.detail = res.data.data.map((item) => {
          return {
            ...item,
            value: item.value == 1 ? true : false,
          };
        });
        this.detail.forEach((item) => {
          if (this.keyOne.includes(item.key)) {
            this.frist.push(item);
          } else if (this.keyTwo.includes(item.key)) {
            this.second.push(item);
          } else if (this.keyThree.includes(item.key)) {
            this.third.push(item);
          }
        });
      });
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  padding: 0 0 20px;

  .card {
    padding: 50px 70px;
    background: #ffffff;
    margin-bottom: 30px;

    .title {
      border-bottom: 1px solid #d8d8d8;

      .shop {
        font-weight: bold;
        font-size: 24px;
        color: #333333;
        display: inline-block;
        margin-right: 10px;

        padding-bottom: 30px;
      }
    }

    .message-item {
      display: flex;
      line-height: 82px;
      border-bottom: 1px solid #d8d8d8;
      align-items: center;

      .desc-title {
        width: 360px;
        display: inline-block;
        text-align: left;
      }

      .desc-from {
        display: inline-block;
        margin-left: 100px;
        font-weight: 400;
        font-size: 16px;
        color: #afafaf;
      }
    }
  }
}
</style>
